export default __webpack_public_path__ + "static/media/praneeth.efe4524e.png";